import { LandingNav } from './landing/LandingNav';
import { HeroSection } from './landing/HeroSection';
import { FeaturesSection } from './landing/FeaturesSection';
import { HowItWorksSection } from './landing/HowItWorksSection';
import { StatsSection } from './landing/StatsSection';
import { DetailedFeaturesSection } from './landing/DetailedFeaturesSection';
import { CapabilitiesMarquee } from './landing/CapabilitiesMarquee';
import { ContactSection } from './landing/ContactSection';
import { FooterSection } from './landing/FooterSection';

export function LandingPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <LandingNav />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <StatsSection />
        <DetailedFeaturesSection />
        <CapabilitiesMarquee />
        <ContactSection />
      </main>
      <FooterSection />
    </div>
  );
}
